export default __webpack_public_path__ + "static/media/empty-state-configurable-activities.e6380c93.png";